import useMoney from '../../../../../../../hooks/useMoney';
import { useOrderValueVisibility } from '../../../../../../../hooks/useOrderValueVisibility';
import LangEnum from '../../../../../../../lang/LangEnum';
import { useTranslation } from '../../../../../../translation/TranslationContext';

interface UseOrderSummaryTotalValueParams {
  labelText?: string;
  tooltip?: LangEnum;
  stackedLabel?: LangEnum;
  value: number;
  isStrikethrough?: boolean;
  isStacked?: boolean;
}

const useOrderSummaryTotalValue = ({
  labelText,
  tooltip,
  stackedLabel,
  value,
  isStrikethrough,
  isStacked,
}: UseOrderSummaryTotalValueParams) => {
  const { translate } = useTranslation();
  const { formatMoney } = useMoney();
  const { shouldHideOrderValues } = useOrderValueVisibility();

  const getVisibleLabel = () => {
    if (isStacked && stackedLabel) {
      return translate(stackedLabel);
    }

    return labelText;
  };

  const visibleLabel = getVisibleLabel();

  return {
    shouldHideOrderValues,
    direction: isStacked ? ('column' as const) : ('row' as const),
    alignItems: isStacked ? ('flex-start' as const) : ('baseline' as const),
    visibleLabel,
    tooltipLabel: visibleLabel ? undefined : tooltip,
    textDecoration: isStrikethrough ? ('line-through' as const) : undefined,
    valueVisibility: shouldHideOrderValues ? ('hidden' as const) : undefined,
    formattedValue: formatMoney(Number.isFinite(value) ? value : 0),
  };
};

export default useOrderSummaryTotalValue;
